import './amplify'
import * as ngHttp from '@angular/common/http'
import * as ngCore from '@angular/core'
import * as ngPlatformBrowser from '@angular/platform-browser'
import * as ngPlatformBrowserAnimations from '@angular/platform-browser/animations'
import * as ngRouter from '@angular/router'
import { environment } from '@attain-apps/fe/web/main/env'
import * as markdown from '@attain-apps/fe/web/main/lib/markdown'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as featureFlags from '@attain-apps/feature-flags'

// NOTE: Importing from './component-bridge/providers' instead of
// './component-bridge' because the barrel (index.ts) intentionally excludes
// providers.ts — it imports from '../components', which would drag the entire
// component tree into any file that touches the barrel (including state/).
import * as componentBridge from './component-bridge/providers'
import * as components from './components'
import { RouteBoundReuseStrategy } from './route-reuse-strategy'

if (environment.production) {
  ngCore.enableProdMode()
}

featureFlags.register(environment.featureFlags)

/**
 * Bootstraps the entire platform
 *
 * Use {@link bootstrapApplication.forApp} when bootstrapping an individual app
 */
export function bootstrapApplication(
  params: bootstrapApplication.Params,
): void {
  ngPlatformBrowser
    .bootstrapApplication(components.root.Component, {
      providers: [
        // TODO: does the ordering here matter? If so, add comments to explain
        store.provideStore({ enableDevtools: !environment.production }),
        router.provideRouter(params),
        {
          provide: ngRouter.RouteReuseStrategy,
          useClass: RouteBoundReuseStrategy,
        },
        ngHttp.provideHttpClient(ngHttp.withInterceptorsFromDi()),
        ngPlatformBrowserAnimations.provideAnimations(),
        markdown.provideMarkdown(),
        ...componentBridge.provide(),
      ],
    })
    .catch(err => console.error(err))
}
export namespace bootstrapApplication {
  export type Params = router.provideRouter.Params
}
